import React, { FC, useRef } from 'react';
import ErrorBox from 'components/molecules/ErrorBox/ErrorBox';
import Loader from 'components/molecules/Loader';
import { useContainerWidth } from 'hooks/general/useContainerWidth';
import _ from 'lodash';
import { calculateFontSize, formatNumWithKMBAlt, getConfig } from 'utils/helperMethods';
import Linechart from 'components/molecules/Linechart';
import { yAxisLabelClass } from './PVMAnalysisDrilldownContainer';
import { classToRemoveScrollbar } from 'components/molecules/MicroIntractions/CopyTOClipBoard';

const barWidthMap: any = {
    4: 30,
    12: 20,
    26: 20,
    52: 11,
};

type Props = {
    drillDownItem: any;
    overflowWidth: any;
    lineChartColors: any;
    lineChartResult: any;
    fields: Array<string>;
    combinedLoading: boolean;
    combinedError: boolean;
};

const yAxisWidth = calculateFontSize(window.innerWidth, 80);
const height = 250; // Math.max(400, calculateContainerHeight(2, 33 + 16 * 2) - 50);

const PVMTrendChart1: FC<Props> = ({
    overflowWidth,
    lineChartColors,
    lineChartResult,
    fields,
    combinedError,
    combinedLoading,
}) => {
    const trendsChartRef = useRef<any>();

    // IF ERROR RETURN ERROR MESSAGE
    if (combinedError && !combinedLoading) return <ErrorBox msg={'Failed to load Data'} />;

    // IF LOADING RETURN LOADER
    if (combinedLoading)
        return (
            <div style={{ height: 370, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Loader />
            </div>
        );

    const containerWidth = Math.min(1200, Math.max(lineChartResult?.data?.length * 100, overflowWidth / 2));

    return (
        <div ref={trendsChartRef}>
            <div className="flex">
                <Linechart
                    padding={[0, 0, 12, 0]}
                    // yAxisConfig={false}
                    xAxisConfig={false}
                    YGrid={false}
                    dataset={[]}
                    height={height}
                    // height={chartHeight}
                    loading={false}
                    chartContainer={`1current-year-sales-line-y`}
                    fields={['period', ...fields]}
                    minBound={lineChartResult?.minVal}
                    maxBound={lineChartResult?.maxVal}
                    width={yAxisWidth} //subtracting the padding
                    xAxisLabelFormatter={(val: any) => {
                        return val;
                    }}
                    yAxisLabelFormatter={(val: any) => {
                        return formatNumWithKMBAlt(val, 2, 2);
                    }}
                    groupedChartColor={lineChartColors}
                    colorKey={'color'}
                    disableIntervalLabel
                />
                <Linechart
                    additionalStyle={{ width: overflowWidth, overflowX: 'scroll' }}
                    additionalClass={classToRemoveScrollbar}
                    // yAxisConfig={false}
                    dataset={lineChartResult?.data || []}
                    height={height}
                    loading={false}
                    chartContainer={`1current-year-sales-line`}
                    fields={['period', ...fields]}
                    minBound={lineChartResult?.minVal}
                    maxBound={lineChartResult?.maxVal}
                    width={containerWidth * 2} //subtracting the padding
                    xAxisLabelFormatter={(val: any) => {
                        return val;
                    }}
                    groupedChartColor={lineChartColors}
                    colorKey={'color'}
                    disableIntervalLabel
                    tooltipFormatter={(xAxis, val, from) => {
                        return {
                            name: from,
                            value: formatNumWithKMBAlt(val, 2, 2),
                        };
                    }}
                />
            </div>
            <p className={`text-center relative ${yAxisLabelClass} mt-6`}>Months </p>
        </div>
    );
};

export default PVMTrendChart1;
